module.exports = __webpack_public_path__ + "fonts/fa-light-300.1b0a9e43.woff2";